import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/App.css";
import App from "@/App";
import FarmersStandaloneApp from "@/farmers_pulse/standalone/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

// Flip to the Farmers Pulse standalone bundle when the build environment
// asks for it — used for `farmerspulse.com` deployments (Dockerfile.farmerspulse.frontend).
const IS_FP_STANDALONE = process.env.REACT_APP_FARMERSPULSE_STANDALONE === "true";
const Root = IS_FP_STANDALONE ? FarmersStandaloneApp : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <Root />
  </QueryClientProvider>
);

registerServiceWorker();
